/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Button } from 'antd';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import { history } from 'app/store';
import { URL } from 'app/constants/mapConstants';
import styled from 'styled-components';
import {
  changeTourMode,
  setMainTourPartDistanceAndDuration,
} from '../../../../actions/Map/tour.full.data.action';
import { progressQueueService } from '../../../Utility/Service/progressQueue.service';
import { Type } from '../../../../constants/TourPoints';
import tourPrevAPI from '../../../../API/tour.prev.api';
import {
  openNotificationWithIcon,
  cachHandler,
} from '../../../Utility/notificationMessage';
import {
  tourFullDataId,
  resaveTour,
  tourOpenedMultiPartAction,
  tourSetActiveMultiPartAction,
  setRequiredFiled,
} from '../../../../actions/FullTour/full_tour_view.action';
import { isTourPublic } from '../../../../constants/tourAccessibilityTypes.constants';
import { getTourLink } from '../../../Utility/utility';
import useSavingLoop from './savingLoop.service';
import pageCache from '../../../../API/cache.service';
import { launchFunction, setFunction, crearFunction } from './delayLaunch';

import GetSwitcher from './getOptimizeFunctionality';
import { setMyTours } from '../../../../actions/Menu/counter.action';

import withTranslations from '../../../HOGs/withTranslations';

const { isSaveInProgress, setSaveProgress } = useSavingLoop;
let timer = null;
let isForceSaving = false;

function AutoSaveTour({
  isRidePlan,
  setPageBlock,
  isWrongRoutesExists,
  isThereAnyWrongRouteInAllTourPages,
  fullScreenMode,
  isShapingDataExists,
  hasUserPermition,
  currentTourId,
  closePreview,
  clearTour,
  tr,
}) {
  const {
    getProgressMarkers,
    isPrograssCompleted,
    removeProgressMarker,
    clearProgressList,
  } = progressQueueService;

  const { tourFullData, authentication, mapPostition, loginData } = useSelector(
    (store) => store
  );
  const { isLoggedIn, user = {} } = authentication;
  const {
    timestamp,
    activeMultiPart,
    isEditMode,
    data: mainData,
    activeTourTab,
    unpaved,
    ferry,
    highway,
    isShapingVisible,
    isTtoVisible,
    isCorrectionEnabled,
    isAutocorrectionEnabled,
    isCorrectViaAvailable,
    isCorrectDragAvailable,
    isFullScreenModeEnabled,
  } = tourFullData;
  const { isModalOpenFAQ } = loginData;
  const { tourType } = mainData;
  const dispatch = useDispatch();

  const leavePageMessage = tr['Changes may not be saved'];

  const [isDataSending, setSendingStatus] = useState(false);

  const checkDragPointExisting = (points) =>
    points?.some((point) => point.type === Type.DRAG);

  const isViaWithoutInfoAndMedia = (point) =>
    !point.title &&
    !point.description &&
    (!point.images || point.images.length === 0);

  const changeClearViaToDrag = (point) => {
    if (isViaWithoutInfoAndMedia(point)) {
      point.setType(Type.DRAG);
    }
    return point;
  };

  const togleSavingStatus = (val) => {
    setPageBlock(val);
    setSendingStatus(val);
  };

  const resave = () => {
    dispatch(resaveTour());
  };

  const getDistanceAndDurationMainPart = () => {
    const tour = { ...tourFullData.data };

    if (tour.multiDay === true) {
      // eslint-disable-next-line
      const data = {
        distance: 0,
        duration: 0,
      };

      tour.parts.map((part) => {
        if (part.distance && part.duration) {
          data.distance += part.distance;
          data.duration += part.duration;

          return part;
        }
        part.points.map((point) => {
          if (point.distance) {
            data.distance += point.distance;
          }
          if (point.duration) {
            data.duration += point.duration;
          }

          return point;
        });

        return part;
      });

      if (data.distance === 0 || data.duration === 0) {
        return null;
      }

      dispatch(setMainTourPartDistanceAndDuration(data));

      return data;
    }
    return null;
  };

  const isMainTourDataAlreadySaved = (mainId, parentId, id) => {
    // it is a huck for fixing a bug with double saving the main tour part after uploading data and pressing Add new day button too fast
    return mainId && !parentId && mainId !== id;
  };

  const isTourPartDataAllreadyBeingSaved = (mainPart, tour, id) => {
    // it is a huck for fixing a bug with double saving a separate tour part after uploading data and pressing Add new day button too fast
    return (
      mainPart.id &&
      tour.part_id &&
      mainPart.parts &&
      mainPart.parts.length > 0 &&
      mainPart.parts[tour.part_id - 1] &&
      mainPart.parts[tour.part_id - 1].parts_id === tour.parts_id &&
      mainPart.parts[tour.part_id - 1].id > 0 &&
      mainPart.parts[tour.part_id - 1].id !== id
    );
  };

  const restoreAndContinue = (id, existedId, user) => {
    // eslint-disable-line
    dispatch(tourFullDataId({ id: existedId }));
    tourPrevAPI.removeTour(id, user);
  };

  const leaveCreateTourPage = (dTitle, dId, dKey) => {
    const mainTour = { ...mainData };
    const { title, id, share_key = '', multiDay } = mainTour; // eslint-disable-line
    isForceSaving = false;
    const link = multiDay
      ? getTourLink(title, id, share_key)
      : getTourLink(dTitle, dId, dKey);
    if (isRidePlan) {
      history.push(link);
    } else {
      publish(way.SAVE_TB_PART_DATA_IN_REDUX, false);
      dispatch(changeTourMode(false));
    }
  };

  const removeEmptyPoints = (parts) => {
    parts.forEach(({ points }) => {
      points.forEach((point, i) => {
        if (point.isEmpty) {
          points.splice(i, 1);
        }
      });
    });
  };

  // eslint-disable-next-line
  const startSaving = (data, newPoints, amp = null) => {
    const tour = amp ? { ...amp } : { ...activeMultiPart };
    const { id = 0 } = user;
    const mainPart = tourFullData.data;
    tour.owner = parseInt(id);

    if (newPoints.length === 0 && !tour.multiDay && tour.part_id > 0) {
      setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
      return;
    }
    if (isTourPublic(tourType)) {
      timer = setTimeout(() => {
        if (timer) clearTimeout(timer);
        pageCache.destroy(URL.TOUR.PUBLIC[0]);
        pageCache.destroy(URL.TOUR.NAF[0]);
        pageCache.destroy(URL.CONTENT.BEST[0]);
      }, 60000);
    }
    pageCache.destroy(URL.TOUR.MY[0]);
    // need to catch public tours without pictures

    tour.points = newPoints;

    tour.pointsData = {
      ...tour.pointsData,
      unpaved,
      ferry,
      highway,
      isShapingVisible,
    };
    if (data.distance > tour.distance) {
      tour.distance = data.distance;
      tour.duration = data.duration;
    }
    tour.zoom = mapPostition.zoom;
    if ((!tour.lat || !tour.lng) && newPoints[0]) {
      tour.lat = newPoints[0].lat;
      tour.lng = newPoints[0].lng;
    }

    if (tour.part_id === 0 && tour.multiDay) {
      const data = getDistanceAndDurationMainPart(); // eslint-disable-line
      tour.distance = data.distance;
      tour.duration = data.duration;
    }

    if (tour.part_id > 0 && !tour.parent_tour_id && mainPart.id) {
      tour.parent_tour_id = mainPart.id;
    }

    tour.rr_type = mainPart.rr_type;
    if (mainPart.rr_id) {
      tour.rr_id = mainPart.rr_id;
    }

    if (tour.parts && tour.parts.length > 1) {
      removeEmptyPoints(tour.parts);
    }

    if (tour.part_id > 0) {
      tour.parent_tour_dist_dur = getDistanceAndDurationMainPart();
    }

    if (isSaveInProgress()) {
      setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
      return;
    }

    setSaveProgress(leavePageMessage, true);
    togleSavingStatus(true);

    tourPrevAPI
      .saveTour(tour)
      .then((resp) => {
        if (resp && resp.response && resp.response.id > 0) {
          const { id, share_key, myToursCount, parts } = resp.response; // eslint-disable-line
          dispatch(setMyTours(myToursCount));
          if (!tour.id || tour.id !== id) {
            // if (
            //   isMainTourDataAlreadySaved(mainPart.id, tour.parent_tour_id, id)
            // ) {
            //   restoreAndContinue(id, mainPart.id, mainPart.user);
            // } else if (isTourPartDataAllreadyBeingSaved(mainPart, tour, id)) {
            //   restoreAndContinue(
            //     id,
            //     mainPart.parts[tour.part_id - 1].id,
            //     mainPart.user
            //   );
            // } else {
            dispatch(
              tourFullDataId({ id, part: tour.part_id, share_key, parts })
            );
            // }
          }
          if (isForceSaving) {
            setTimeout(() => {
              leaveCreateTourPage(tour.title, id, share_key);
            }, 100);
          }
        } else {
          console.log(resp);
        }
      })
      .catch(cachHandler)
      .finally(() => {
        setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
      });
  };

  const prepareDataToSave = (obj = {}) => {
    const { isSavingBlocked = false, activeMultiPart: tmpActiveMultiPart } =
      obj;

    const isDragPointExists = checkDragPointExisting(tmpActiveMultiPart.points);

    const data = {
      // eslint-disable-line
      distance: 0,
      duration: 0,
      timestamp: 0,
    };

    if (tmpActiveMultiPart && !tmpActiveMultiPart.points) {
      setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
      // console.info('tmpActiveMultiPart.points', tmpActiveMultiPart);
      return;
    }

    if (tmpActiveMultiPart && typeof tmpActiveMultiPart.points === 'string') {
      tmpActiveMultiPart.points = JSON.parse(tmpActiveMultiPart.points);
    }

    const newPoints = tmpActiveMultiPart.points.map((point) => {
      const { distance, duration, isEmpty, type } = point;
      if (distance) {
        data.distance += distance;
      }
      if (duration) {
        data.duration += duration;
      }

      if (!isEmpty) {
        if (
          !isDragPointExists &&
          type === Type.VIA &&
          !tmpActiveMultiPart.multiDay &&
          tmpActiveMultiPart.part_id > 0
        ) {
          return changeClearViaToDrag({ ...point });
        }
        return { ...point };
      }
      return null;
    });

    if (isEditMode && !isSavingBlocked) {
      // need to check user access
      startSaving(
        data,
        newPoints.filter((p) => p),
        tmpActiveMultiPart
      );
      getDistanceAndDurationMainPart();
    } else {
      setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
    }

    if (
      tmpActiveMultiPart &&
      tmpActiveMultiPart.multiDay === true &&
      activeTourTab === '0'
    ) {
      return; // eslint-disable-line
    }
  };

  const launchSaving = () => {
    const index = getProgressMarkers().indexOf(timestamp);
    if (index > -1) {
      removeProgressMarker(index);
      if (isPrograssCompleted()) {
        setFunction(prepareDataToSave, {
          activeMultiPart: { ...activeMultiPart },
        });
        prepareDataToSave({
          isSavingBlocked: true,
          activeMultiPart: { ...activeMultiPart },
        });
      } else {
        console.log(
          'There are not completed progress',
          getProgressMarkers().slice(),
          'finist',
          timestamp
        );
      }
    }
  };

  useEffect(() => {
    if (timestamp) {
      launchSaving();
    }
  }, [timestamp]);

  useEffect(() => {
    if (mainData.id) {
      setTimeout(() => {
        crearFunction();
      }, 3000);
    }
  }, [isEditMode]);

  const displayRequiredFiled = () => {
    const tour = { ...activeMultiPart };
    dispatch(
      setRequiredFiled({
        title: !!tour.title, // convert value to boolean
        points: tour.points.filter((point) => !point.isEmpty).length !== 0,
        img: !!tour.imgids,
        desc: !!tour.description,
      })
    );

    const handler = (e) => {
      document.removeEventListener('click', handler, false);
      if (e.target.classList.contains('saveTour')) return;
      dispatch(
        setRequiredFiled({
          title: true, // convert value to boolean
          points: true,
          img: true,
          desc: true,
        })
      );
    };
    document.addEventListener('click', handler, false);
  };

  const callFixedPoints = async () => publish(way.DRIVE_FIXED_POINTS, {});

  const clickHandler = () => {
    callFixedPoints().then(() => {
      fullScreenMode('hidden', () => {});
      if (!isLoggedIn) {
        openNotificationWithIcon('info', tr['Login to view this tour']);
        return;
      }

      const mainTour = { ...mainData };

      if (isTourPublic(tourType) && !mainTour.imgids) {
        const setAllTab = async () =>
          dispatch((disp) => {
            disp(tourOpenedMultiPartAction('0'));
            disp(tourSetActiveMultiPartAction(0));
          });
        setAllTab().then(displayRequiredFiled());
        cachHandler({
          message: tr['Public tour should have at least one picture'],
        });
        return;
      }

      if (!mainTour.title) {
        displayRequiredFiled();
        cachHandler({ message: tr['Title of the tour is missing'] });
        return;
      }

      if (!mainTour.points) {
        console.log(tourFullData);
        console.trace();
      }

      if (typeof mainTour.points === 'string') {
        mainTour.points = JSON.parse(mainTour.points);
      }

      if (
        mainTour.points.filter((point) => !point.isEmpty).length === 0 &&
        !mainTour.multiDay
      ) {
        displayRequiredFiled();
        cachHandler({ message: tr['Tour should have at least one point'] });
        return;
      }

      if (isPrograssCompleted()) {
        isForceSaving = true;
        launchFunction(prepareDataToSave, { activeMultiPart: mainData });
      } else {
        clearProgressList();
        setSaveProgress(leavePageMessage, true);
        togleSavingStatus(true);
        setTimeout(() => {
          setSaveProgress(leavePageMessage, false, togleSavingStatus, resave);
          isForceSaving = true;
          launchFunction(prepareDataToSave, { activeMultiPart: mainData }); // need to check moving the param into function !!! //fixed ignoring click on the save button
        }, 3000);
        console.info('Busy saving at the moment');
      }
    });
  };

  const SaveButton = () => {
    if (isDataSending) {
      return (
        <Button
          type="primary"
          size="large"
          className="not-allowed-save-tour"
          style={{ cursor: 'not-allowed' }}
        >
          {`${tr['Saving']}...`}
        </Button>
      );
    }
    return (
      <Button
        type="primary"
        size="large"
        className="save-tour-button"
        onClick={clickHandler}
      >
        {tr['Save and view tour']}
      </Button>
    );
  };

  const SaveTourWrapperDiv = styled.div`
    z-index: 2147483647;
    position: fixed;
    left: 221px;
    top: 10px;
    display: flex;
  `;

  const getSwitcherComponent = (someStyle) => {
    return (
      <GetSwitcher
        isCorrectionEnabled={isCorrectionEnabled}
        isAutocorrectionEnabled={isAutocorrectionEnabled}
        isCorrectViaAvailable={isCorrectViaAvailable}
        isCorrectDragAvailable={isCorrectDragAvailable}
        isFullScreenModeEnabled={isFullScreenModeEnabled}
        isCorrectSwitcherAvailb={isCorrectionEnabled || isRidePlan}
        isModalOpenFAQ={isModalOpenFAQ}
        tr={tr}
        isWrongRoutesExists={isWrongRoutesExists}
        unpaved={unpaved}
        highway={highway}
        ferry={ferry}
        isShapingVisible={isShapingVisible}
        isEditMode={isEditMode}
        style={someStyle}
        isTtoVisible={isTtoVisible}
        isRidePlan={isRidePlan}
        hasUserPermition={hasUserPermition}
        currentTourId={currentTourId}
        closePreview={closePreview}
        fullScreenMode={fullScreenMode}
        clearTour={clearTour}
      />
    );
  };

  if (tourFullData.isFullScreenModeEnabled) {
    const someStyle = {
      zIndex: 2147483647,
      top: '10px',
      display: 'flex',
    };
    return ReactDOM.createPortal(
      <>
        <SaveTourWrapperDiv className="saveTour">
          <SaveButton />
        </SaveTourWrapperDiv>
        {getSwitcherComponent(someStyle)}
      </>,
      document.querySelector('.TourFullmap')
    );
  }

  return (
    <>
      {isEditMode && (
        <div className="saveTour">
          <SaveButton />
        </div>
      )}
      {getSwitcherComponent({})}
    </>
  );
}
AutoSaveTour.displayName = 'AutoSaveTour';

export default withTranslations(AutoSaveTour);
